import { useCallback } from 'react';
import { HOUSE_ADS, sceneFor, type HouseAd } from '../ads/houseAds';
import { endpoints } from '../services/api';
import { usePolling } from './usePolling';

/** Ads managed at /admin (refreshed every 30 minutes), or the built-in starters if none. */
export function useAds(enabled: boolean): HouseAd[] {
  const load = useCallback(
    () =>
      endpoints.ads().then((r) =>
        r.ads.map<HouseAd>((a, i) => ({
          id: a.id,
          advertiser: a.advertiser,
          headline: a.headline,
          body: a.body,
          cta: a.cta,
          url: a.url,
          image: a.image,
          scene: sceneFor(i),
        })),
      ),
    [],
  );
  const { data } = usePolling(enabled ? 'ads' : null, load, 30 * 60_000);
  return data?.length ? data : HOUSE_ADS;
}
